const INSURANCE_NAMES = {
  GROUP_ACCIDENTAL_INSURANCE: 'Group Personal Accident Insurance (GPA)',
  GROUP_TERM_INSURANCE: 'Group Term Life Insurance',
  ACCIDENTAL_INSURANCE: 'Accidental Insurance',
  HEALTH_INSURANCE: 'Health Insurance',
  TERM_LIFE_INSURANCE: 'Term Life Insurance',
  MOTOR_INSURANCE: 'Motor Insurance',
  GROUP_HEALTH_INSURANCE: 'Group Health Insurance',
  GROUP_HEALTH_INSURANCE_PARENTS: 'Group Health Insurance (Parents)',
  MARINE_INSURANCE: 'Marine Insurance',
  FIRE_INSURANCE: 'Fire Insurance',
  GROUP_SUPER_TOP_UP_INSURANCE: 'Group Super Top Up Insurance',
  GROUP_OPD_HEALTH_INSURANCE: 'Group OPD Health Insurance',
  GROUP_CRITICAL_ILLNESS_INSURANCE: 'Group Critical Illness Insurance',
  GROUP_TOP_UP_INSURANCE: 'Group Top-up Insurance',
  CAR_INSURANCE: 'Car Insurance',
  BIKE_INSURANCE: 'Bike Insurance',
  TRAVEL_INSURANCE: 'Travel Insurance',
}

export { INSURANCE_NAMES }
